import classNames from 'classnames';
import RoundedButtonPrimary from '../../../components/button/rounded-button-primary/RoundedButtonPrimary';
import styles from './payment-method-button.module.less';

const PaymentMethodButton = ({ className, ...props }) => {
    return <RoundedButtonPrimary className={classNames(styles.button, className)} {...props} />;
};

export default PaymentMethodButton;
